export function getTrackingPagePath(document: Document): string {
  return decodeURIComponent(document.location.pathname).toLowerCase();
}
